import {listener, onReady} from "../../../../modules/vegas/js/util";
import {VGFormSender} from "vgformsender";
import axios from "axios";
import VGInputMask from "../../ui/inputmask/inputmask";

function hideBSModal() {
	let bsModalShow = document.querySelector('.modal.show');
	if (bsModalShow) {
		let bsModal = bootstrap.Modal.getInstance(bsModalShow);
		bsModal.hide();
	}
}

listener('submit', 'form[data-auth-required]:not([data-auth="true"])', (form, e) => {
	let btn = form.querySelector('button[type=submit]');
	let btnPreviousText = btn.innerText;
	btn.disabled = true;
	btn.innerText = 'Отправляем...';

	axios.post(form.action, new FormData(form), {
		headers: {
			"X-Check-Auth": true,
		}
	}).then(response => {
		if (response.data.error) {
			if (response.data.login_required) {
				document.getElementById('modal-auth-required')?.remove();
				document.getElementById('modals-container').insertAdjacentHTML('afterend', response.data.view);
				let modal = document.getElementById('modal-auth-required');
				new bootstrap.Modal(modal).show();
				modal.relatedAuthRequiredForm = form;

				new VGInputMask().init(modal);
			} else {
				alert(response.data.msg);
			}
		} else {
			form.dataset.auth = true;

			new VGFormSender(form).submit({
				success: () => {
					hideBSModal();
				},
				error: () => {
					hideBSModal();
				}
			});

			form.requestSubmit();
		}
	}).finally(() => {
		btn.innerText = btnPreviousText;
		btn.disabled = false;
	});
}, true);

listener('submit', '#form-auth-required', (form, e) => {
	let modal = form.closest('.modal');
	let relatedForm = modal.relatedAuthRequiredForm;

	let err = form.querySelector('.error');
	err.classList.add('d-none');

	let btn = form.querySelector('button[type=submit]');
	let btnPreviousText = btn.innerText;
	btn.innerText = 'Проверяем...';
	btn.disabled = true;

	axios.post(form.action, new FormData(form))
		.then(response => {
			if (response.data.error) {
				err.innerText = response.data.msg;
				err.classList.remove('d-none');
			} else {
				bootstrap.Modal.getInstance(modal).hide();
				relatedForm.requestSubmit();
			}
		})
		.finally(() => {
			btn.innerText = btnPreviousText;
			btn.disabled = false;
		})
	;
}, true);
